import { SelectOption } from '../../types'

/**
 * Create SelectOptions from enum object
 * The behaviour is not guaranteed when using a Typescript enum, so it is recommended to use object instead.
 * @param enumObject {Record<string, string | number>} This param MUST be object, and not a Typescript enum
 * @param translateFunction
 * @param translationKey
 * @returns {SelectOption[]} An array of SelectOptions
 */
export const createOptionsFromEnum = (
  enumObject: Record<string, string | number>,
  translateFunction: (key: string) => string,
  translationKey: string
): SelectOption[] => {
  return Object.values(enumObject).map((value) => {
    return {
      value: String(value),
      label: translateFunction(`${translationKey}.${value}`),
    }
  })
}
